/* START GLOBAL CONSTANTS */
export const RET_KEYS = ['gctvid', 'appcpid', 'vencpid', 'appaffid', 'venaffid', 'appcpidlts', 'apprid', 'venlno',
  'applno'];
export const EVENT_ELE_ARR = ['thankyou', 'setupfinish', 'byb', 'creditcheck'];
export const EVENT_JOUR_ARR = ['cardapplication', 'cardupgrade'];
export const EVENT_CONV_STEP_ARR = ['suppapplicationcomplete', 'applicationsubmit', 'suppapplicationstart',
  'applicationstart', 'upgradestart', 'upgradecomplete'];
export const EVENT_ELE_START = ['byb', 'creditcheck'];
export const EVENT_ELE_SUBMIT = ['thankyou', 'setupfinish'];
export const EVENT_NO_SUBMIT = ['event5', 'event24'];
export const E2_DOMAINS = ['e1qglobal', 'qwww', 'qhome', 'qm', 'e2q', 'e2s', 'ssoq', 'qcardappdacq', 'qq1cardappdacq',
  'dxpcpsapp1-qa', 'dxp-cardapp-v-qa', 'dxpcardappf2-qa', 'dxp-cardapp-qa'];
export const INTERNAL_DOMAINS = [
  'americanexpress.', '.americanexpress', 'americanexpress-', 'amex', 'american-express', 'aexp.com',
  'membershiprewards.', 'experiandirect.com', 'brassring.com', 'aeprepaid.com', 'bonuspoint', 'openforum.com',
  'davidjones', 'ibanking-services.com', 'aetclocator.com', 'res99.com', 'deltaskymilescard.com',
  'isopenrightforyou.com', 'yourcarrentalclaim.com', 'goldcarddestinations.com', 'guidestar.org', 'open.com',
  'takecharge.com', 'fx4you.com', 'plumcard.com', 'travelocity.com', 'carddefence.net', 'corporate-platinum.de',
  'areyouacardmember.com', 'solicitalatarjeta.com', 'as00.estara.com', '75.101.129.171', 'shopandmilesjourneys.com',
  'iddefence', 'acceptpay.com', 'reservetravelprivileges.com', 'maxvantagemeetings.com', 'goldyearendsummary.com',
  'axpbillpay.com', 'aceinsurance.com', 'leisure.travelpn.com', 'securweb.biz', 'ukbo.savvislive.com',
  'ebm.cheetahmail.com', 'businesscreditsecure.com', 'flweb20.ypsilon.net', 'getcurrency.com', 'magroup-online.com',
  'co-store.com', 'axbtportal.com', 'dailygood.com', 'mytrueearnings.com', 'searchmanager.com', 'xml4.eotis.com',
  'insuranceedge.com', 'platinumcardtravel.at', 'morethanjustacard.fi', 'aexp.se', 'paycenter.com', 'nextpedition.com',
  'ezrez.com', 'serve.com', 'admanager.com', 'paysimple.com', 'yourbuzz.com', 'openbusinesstravel.com', 'veri.com'];
/*
export const HOST_NAMES = ['-dev', '-prepod', '-qa'];
*/
/* END GLOBAL CONSTANTS */
/* START INTERNATIONAL CONSTANTS */
export const HOST_NAMES = ['e1qglobal', '-dev', 'qwww', 'qhome', 'qm',
  '-qa', 'e2q', 'e2', 'recetteqs', 'aexp.com',
];
export const OMN_ARR = ['omn_hierarchy', 'omn_pcnnumber', 'omn_entrypoint', 'omn_products', 'omn_zipcode',
  'omn_applyflow', 'omn_cardtype', 'omn_rsvp', 'omn_events',
];
export const OMN_OBJ_ARR = ['hierarchy', 'pcnnumber', 'entrypoint', 'products', 'zipcode',
  'applyflow', 'cardtype', 'rsvp', 'events',
];
export const ITAG_ARR = ['itag_hierarchy', 'itag_pcnnumber', 'itag_eep', 'itag_products', 'itag_zipcode',
  'itag_applyflow', 'itag_cardtype', 'itag_rsvp', 'itag_events',
];
/* END  INTERNATIONAL CONSTANTS */
/* START DOMESTIC CONSTANTS */
export const OMN_ARR_DOMESTIC = ['omn_entrypoint', 'omn_products', 'omn_zipcode', 'omn_applyflow', 'omn_events',
  'omn_pmc'];
export const OMN_OBJ_ARR_DOMESTIC = ['omn.entrypoint', 'omn.products', 'omn.zipcode', 'omn.applyflow', 'omn.events',
  'omn.pmc'];
export const ITAG_ARR_DOMESTIC = ['itag_entrypoint', 'itag_products', 'itag_zipcode', 'itag_applyflow', 'itag_events',
  'itag_pmc'];
export const INTERNAL_DOMAINS_DOMESTIC = ['theopenappcenter.com', 'servevirtual.net', 'bluebirdmoney.com', 'amextravel.com', ...[INTERNAL_DOMAINS]];
/* END DOMESTIC CONSTANTS */
/* EU CONSENT CONSTANTS */
export const EU_MARKET_LIST = ['FR', 'ES', 'GB', 'UK', 'NL', 'DE', 'IT', 'FI', 'SE', 'AT', 'NO'];
